import classNames from "classnames";
import React from "react";
import { IconComponent } from "../types";
import { CSS_CLASSES } from "./tag-css-classes";
import { TagIconColorOption } from "./tag.types";

export type TagIconProps = {
  /**
   * Use this to add an icon of the tag content
   */
  icon?: IconComponent;

  /**
   * Controls the color of the tag icon.
   */
  color: TagIconColorOption;

  /**
   * Use this to select position of icon inside tag content
   */
  position: "start" | "end";

  /**
   * Apply/override styling by passing in custom CSS class-name(s) using this prop.
   */
  className?: string;
};

export const TagIcon: React.FC<TagIconProps> = ({ icon: Icon, color, position, className }) => {
  const iconClasses = classNames(
    CSS_CLASSES.TAG_ICON,
    position === "start" ? CSS_CLASSES.TAG_ICON_START : CSS_CLASSES.TAG_ICON_END,
    className
  );
  return Icon ? <Icon size="1em" color={color} className={iconClasses} /> : null;
};
